import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import ScrollBooster from "scrollbooster";
import Header from "../components/Header";
import CardItem from "../components/CardItem";
import CardModal from "../components/Modal";
import "../App.css";
import axios from "axios";
import { SERVER_URL } from "../config/SERVER_URL";
import GIF from "../assets/images/NEDEN-OLMASIN-GIF-15.06.gif";
import UABLogo from "../assets/vectors/uab-logo.svg";
import YoutubeIcon from "../assets/vectors/youtube-white.svg";
import InstagramIcon from "../assets/vectors/instagram-logo-white.svg";
import TwitterIcon from "../assets/vectors/twitter-white.svg";
const zoomIn = keyframes`
    from {
      transform: scale(0.7,0.7);
    }
    to {
      transform: scale(1,1);
    }
`;
const Wrapper = styled.div`
  transition: 2s;
  animation: ${zoomIn} 2s ease-in-out forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  /* flex-wrap: wrap; */
  width: 100%;
  /*   height: 100%; */
  animation-delay: 3s;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
`;
const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100% - 80px);
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f9f9f9; //#f9f9f9
  z-index: 3;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & > div {
    display: flex;
    flex-direction: column;
    position: relative;

    & > img {
      box-shadow: inset 0px 0px 40px 40px #f9f9f9;
      border-radius: 45%;
    }
    & > div {
      background: #1d4666;
      position: absolute;
      color: #fff;
      padding: 20px;
      font-weight: 600;
      bottom: 60px;
      left: 21%;
      @media screen and (max-width: 425px) {
        bottom: 70px;
        left: 16%;
      }
    }
  }
`;
const Footer = styled.div`
  background: #315c89;
  width: 100%;
  position: fixed;
  bottom: 0;
`;
const FooterWrapper = styled.div`
  padding: 0 50px;
  display: flex;

  justify-content: space-between;
  @media screen and (max-width: 600px) {
    padding: 0;
  }
  & > img {
    height: 50px;
    padding: 20px 0px;

    @media screen and (max-width: 425px) {
      width: 150px;
    }
  }
`;
const Social = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  & > a {
    margin-right: 15px;
    & > img {
      @media screen and (max-width: 425px) {
        width: 20px;
      }
    }
    & > img {
      @media screen and (max-width: 425px) {
        width: 20px;
      }
    }
  }
`;

const dissolve = keyframes`
    from {
      opacity:1
    }
    to {
      opacity: 0;
    }
`;
const MiniTutorial = styled.img`
  position: fixed;
  left: 0;
  bottom: 120px;
  width: 100px;
  height: 100px;
  z-index: 2;
  padding: 3px;
  background: #315c89;
  animation: ${dissolve} 40s ease-in-out forwards;

  @media screen and (max-width: 425px) {
    width: 50px;
    height: 50px;
  }
`;
function Main() {
  const url = SERVER_URL;
  const [openModal, setOpenModal] = useState(false);
  const [allCards, setAllCards] = useState([]);
  const [videoList, setVideoList] = useState([]);
  const [data, setData] = useState([]);
  const [selectedCard, setSelectedCard] = useState({});

  const [columnCount, setColumnCount] = useState(1);
  const [startColumn, setStartColumn] = useState(0);
  const [overlayActive, setOverlayActive] = useState(true);

  const MAX_COLUMN_ITEM = 3;
  let sb;
  let centerCount = 0;

  useEffect(() => {
    setTimeout(() => {
      setOverlayActive(false);
    }, 3000);
  }, []);

  const shuffle = (array) => {
    var ctr = array.length,
      temp,
      index;

    while (ctr > 0) {
      index = Math.floor(Math.random() * ctr);
      ctr--;
      temp = array[ctr];
      array[ctr] = array[index];
      array[index] = temp;
    }
    return array;
  };
  useEffect(() => {
    if (data.length <= 0) {
      /* setAllCards(dummy);
        setVideoList(shuffle(dummy)); */
      axios
        .get(SERVER_URL + "cards")
        .then(function (response) {
          // handle success
          const sampleData = [...response.data];
          setData(sampleData);

          setAllCards(sampleData);
          let list = sampleData;
          setVideoList(shuffle(list).filter((item, i) => i < 4));
          const calculateCol = calculateColumnCount(
            sampleData ? sampleData.length : 0
          );

          const startCol = (calculateCol - 1) / 2;
          setData(mappingColumns(sampleData, calculateCol, startCol));
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    }
  }, []);

  const calculateColumnCount = (itemCount = 0) => {
    const a0 = 5;
    let aN = 0;
    let calculatedColumnCount = 0;
    let i = 1;
    while (calculatedColumnCount == 0) {
      aN = aN + Math.pow(2, i - 1) * a0;
      if (itemCount < aN) {
        calculatedColumnCount = 2 * (i - 1) + 1;
      }
      i++;
    }

    setColumnCount(calculatedColumnCount);
    setStartColumn((calculatedColumnCount - 1) / 2);

    return calculatedColumnCount;
  };

  const calculateColumnCountOld = (items) => {
    let max_width = 4000;
    let max_height = 3000;
    let card_width = 300;
    let card_height = 150;

    //calculation with items

    if (items.length <= 10) {
      setColumnCount(3);
    } else if (items.length <= 30) {
      setColumnCount(5);
    } else if (items.length <= 70) {
      setColumnCount(7);
    } else if (items.length <= 150) {
      setColumnCount(9);
    }
    setStartColumn((columnCount - 1) / 2);

    //t = 10
    //a1 = t + 2y
  };

  const mappingColumns = (items, column_count = 1, start_column = 0) =>
    items.map((item, index) => ({
      ...item,
      column: whichColumn(index, column_count, start_column),
    }));

  const whichColumn = (index, column_count = 1, start_column = 0) => {
    let temp = (index + 1) % column_count;

    temp = temp === 0 ? column_count : temp;

    const operator = temp % 2 === 0 ? 1 : -1;
    const difference = Math.floor(temp / 2);
    const columnIndex = start_column + operator * difference;
    return columnIndex;
  };

  const handleClick = (card) => {
    setSelectedCard(card);
    setOpenModal(true);
  };

  const setupExample1 = () => {
    const viewport = document.querySelector(".example1 .viewport");
    const container = document.querySelector(".example1 .content");
    sb = new ScrollBooster({
      viewport: viewport,
      content: container,
      scrollMode: "transform",
      friction: 0.05, //todoo need calibrate
    });
    centerView();
  };

  const initDemo = () => {
    setupExample1();
  };

  const centerView = () => {
    if (centerCount !== 0) return;

    const viewport = document.querySelector(".example1 .viewport");
    const container = document.querySelector(".example1 .content");
    const offsetX = container.scrollWidth - viewport.offsetWidth;
    const offsetY = container.scrollHeight - viewport.offsetHeight;
    sb.setPosition({
      x: offsetX / 2,
      y: offsetY / 2,
    });
    centerCount = 1;
  };

  if (document.readyState !== "loading") {
    initDemo();
  } else {
    document.addEventListener("DOMContentLoaded", initDemo);
  }

  return (
    <>
      {overlayActive && (
        <Overlay>
          <div>
            <img src={GIF} alt="" />
            <div>Tüm soruları görmek için kaydırın</div>
          </div>
        </Overlay>
      )}

      <MiniTutorial src={GIF} alt="" />

      <Header />

      <div className="example example1">
        <div className="viewport">
          <div className="content">
            <Wrapper name="wrapper">
              {Array(columnCount)
                .fill(0)
                .map((item, index) => (
                  <Column
                    name="column"
                    key={index}
                    style={{ paddingTop: index % 2 !== 0 ? "100px" : "" }}
                  >
                    {data &&
                      data.map((card, i) =>
                        card.column == index ? (
                          <CardItem
                            card={card}
                            url={url}
                            handleClick={handleClick}
                            key={i}
                            test={i}
                          />
                        ) : (
                          ""
                        )
                      )}
                  </Column>
                ))}
            </Wrapper>
          </div>
        </div>
        {openModal && (
          <CardModal
            url={url}
            handleClick={handleClick}
            setOpenModal={setOpenModal}
            selectedCard={selectedCard}
            videoList={videoList}
          />
        )}
      </div>
      <Footer>
        <FooterWrapper>
          <img src={UABLogo} alt="uab" width="200" />
          <Social>
            <a href="https://twitter.com/KANAListanbul" target="_blank">
              {" "}
              <img src={TwitterIcon} alt="" width="25" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCl4Q9d6eXbuQl44PKjJEXIg"
              target="_blank"
            >
              {" "}
              <img src={YoutubeIcon} alt="" width="25" />
            </a>
            <a href="https://www.instagram.com/kanalistanbul" target="_blank">
              {" "}
              <img src={InstagramIcon} alt="" width="25" />
            </a>
          </Social>
        </FooterWrapper>
      </Footer>
    </>
  );
}
export default Main;
